import { ElNotification } from 'element-plus';

export const notification = (title: string) =>
  ElNotification.success({
    title,
    message: '',
    position: 'bottom-right',
  });
